import { Action } from '@ngrx/store';
import { type } from '../../util/util';
import { ICredentials, IAuthenticationResult, ILoginResult, IUpdatePassword } from '../../../authentication/types';

export const ActionTypes = {
    SERVER_LOGIN:           type('[Data Authentication] Server Login'),
    SERVER_LOGIN_SUCCESS:   type('[Data Authentication] Server Login Success'),
    SERVER_LOGIN_FAIL:   type('[Data Authentication] Server Login Failure'),
    SERVER_LOGOUT:          type('[Data Authentication] Server Logout'),
    SERVER_LOGOUT_SUCCESS:  type('[Data Authentication] Server Logout Success'),
    SERVER_RESET_PASSWORD:  type('[Data Authentication] Server Reset Password'),
    SERVER_RESET_PASSWORD_SUCCESS:   type('[Data Authentication] Server Reset Password Success'),
    SERVER_RESET_PASSWORD_FAIL: type('[Data Authentication] Server Reset Password Failure'),
    SERVER_UPDATE_PASSWORD:  type('[Data Authentication] Server Update Password'),
    SERVER_UPDATE_PASSWORD_FAIL: type('[Data Authentication] Server Update Password Failure'),
    SERVER_UPDATE_PASSWORD_SUCCESS:   type('[Data Authentication] Server Update Password Success'),
    SERVER_MFA_LOGIN: type('[Data Authentication] Server Mfa Login'),
    SERVER_MFA_LOGIN_SUCCESS: type('[Data Authentication] Server Mfa Login Success'),
    SERVER_MFA_LOGIN_FAIL: type('[Data Authentication] Server Mfa Login Failure'),
    SAVE_MFA_AUTH_TYPE: type('[Data Authentication] Save Mfa Auth Type'),
    SAVE_MFA_AUTH_TYPE_SUCCESS: type('[Data Authentication] Save Mfa Auth Type Success'),
    SAVE_MFA_AUTH_TYPE_FAIL: type('[Data Authentication] Save Mfa Auth Type Failure'),
    RESEND_MFA_CODE: ('[Data Authentication] Resend Mfa Code'),
    RESEND_MFA_CODE_SUCCESS: ('[Data Authentication] Resend Mfa Code Success'),
    RESEND_MFA_CODE_FAIL: ('[Data Authentication] Resend Mfa Code Failure')
};

// Actions for Server Api connection
export class ServerLoginAction implements Action {
  readonly type = ActionTypes.SERVER_LOGIN;
  constructor(public payload: ICredentials) {}
}

export class ServerLoginSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_LOGIN_SUCCESS;
  constructor(public payload: ILoginResult) {}
}

export class ServerLoginFailAction implements Action {
  readonly type = ActionTypes.SERVER_LOGIN_FAIL;
  constructor(public payload: any) {}
}

export class ServerLogoutAction implements Action {
  readonly type = ActionTypes.SERVER_LOGOUT;
  constructor(public payload: any) {}
}
export class ServerLogoutSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_LOGOUT_SUCCESS;
  constructor(public payload: IAuthenticationResult) {}
}

export class ServerResetPasswordAction implements Action {
  readonly type = ActionTypes.SERVER_RESET_PASSWORD;
  constructor(public payload: ICredentials ) {}
}

export class ServerResetPasswordSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_RESET_PASSWORD_SUCCESS;
  constructor(public payload: IAuthenticationResult ) {}
}

export class ServerResetPasswordFailAction implements Action {
  readonly type = ActionTypes.SERVER_RESET_PASSWORD_FAIL;
  constructor(public payload: any ) {}
}

export class ServerUpdatePasswordAction implements Action {
  readonly type = ActionTypes.SERVER_UPDATE_PASSWORD;
  constructor(public payload: IUpdatePassword ) {}
}
export class ServerUpdatePasswordFailAction implements Action {
  readonly type = ActionTypes.SERVER_UPDATE_PASSWORD_FAIL;
  constructor(public payload: any ) {}
}

export class ServerUpdatePasswordSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_UPDATE_PASSWORD_SUCCESS;
  constructor(public payload: IAuthenticationResult ) {}
}

export class ServerMfaLoginAction implements Action {
  readonly type = ActionTypes.SERVER_MFA_LOGIN;
  constructor(public payload: ICredentials) {}
}

export class ServerMfaLoginSuccessAction implements Action {
  readonly type = ActionTypes.SERVER_MFA_LOGIN_SUCCESS;
  constructor(public payload: ILoginResult) {}
}

export class ServerMfaLoginFailAction implements Action {
  readonly type = ActionTypes.SERVER_MFA_LOGIN_FAIL;
  constructor(public payload: any) {}
}

export class SaveMfaAuthTypeAction implements Action {
  readonly type = ActionTypes.SAVE_MFA_AUTH_TYPE;
  constructor(public payload: any) {}
}

export class SaveMfaAuthTypeSuccessAction implements Action {
  readonly type = ActionTypes.SAVE_MFA_AUTH_TYPE_SUCCESS;
  constructor(public payload: any) {}
}

export class SaveMfaTypeFailAction implements Action {
  readonly type = ActionTypes.SAVE_MFA_AUTH_TYPE_FAIL;
  constructor(public payload: any) {}
}

export class ResendMfaCodeAction implements Action {
  readonly type = ActionTypes.RESEND_MFA_CODE;
  constructor(public payload: any) {}
}

export class ResendMfaCodeSuccessAction implements Action {
  readonly type = ActionTypes.RESEND_MFA_CODE_SUCCESS;
  constructor(public payload: any) {}
}

export class ResendMfaCodeFailAction implements Action {
  readonly type = ActionTypes.RESEND_MFA_CODE_FAIL;
  constructor(public payload: any) {}
}

export type Actions
  =
  | ServerLoginAction
  | ServerLoginSuccessAction
  | ServerLoginFailAction
  | ServerLogoutAction
  | ServerLogoutSuccessAction
  | ServerResetPasswordAction
  | ServerResetPasswordSuccessAction
  | ServerResetPasswordFailAction
  | ServerUpdatePasswordAction
  | ServerUpdatePasswordFailAction
  | ServerUpdatePasswordSuccessAction
  | ServerMfaLoginAction
  | ServerMfaLoginSuccessAction
  | ServerMfaLoginFailAction
  | SaveMfaAuthTypeAction
  | SaveMfaAuthTypeSuccessAction
  | SaveMfaTypeFailAction
  | ResendMfaCodeAction
  | ResendMfaCodeSuccessAction
  | ResendMfaCodeFailAction;



// WEBPACK FOOTER //
// ./src/app/stateManagement/actions/data/authentication.ts